// extracted by mini-css-extract-plugin
export default {"root":"grade_and_rate_cell___root___a5e9b57c"};